module.exports = "/images/hydrologic-advisory@3x.png?b7eb22d96d28d19cc56bd93e05befa15";